import { GraphQlClient } from '@intelipost-js/secure-providers';
import '@babel/polyfill';

export default {
  async getAppAndInstalation({ commit }, app_id) {
    try {
      const query = await GraphQlClient.query(`
        query {
          appAndInstallation(app_id: "${app_id}"){
            app {
              id
              name
              imgUrl
              description
              subtitle
              schemaBased
              category
              visible
              is_public
              public_doc
              actions {
                operation
                params
              }
             contact
          }
          installation {
              app_id,
              client_id,
              app_config,
              api_key,
              installation_id,
              status,
          }
      }
        }
      `);
      const data = query.data.appAndInstallation;
      commit('setAppDetails', data);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-edit/store/actions.js